import React from 'react';
import { Box, Typography } from '@mui/material';
import SearchInput from '../../../../components/inputs/SearchInput';
import styles from './EVNHeader.styles';
import DirectionsRailwayIcon from '@mui/icons-material/DirectionsRailway';

const EVNHeader = ({
  title = 'EVNs',
  onSearch,
  searchQuery,
  setSearchQuery,
}) => (
  <Box sx={styles.headerRow}>
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <DirectionsRailwayIcon sx={{ ...styles.pageTitle, mr: 1 }} />
      <Typography sx={styles.pageTitle}>{title}</Typography>
    </Box>

    <SearchInput
      value={searchQuery}
      onChange={setSearchQuery}
      onSearch={onSearch}
    />
  </Box>
);

export default EVNHeader;
